import React, { useState } from 'react';
import { VideoCard, VideoCardProps } from './VideoCard';
import { AddInspirationModal } from './AddInspirationModal';
import { Search, Filter, ArrowUpDown, Plus } from 'lucide-react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { cn } from '../lib/utils';
// Mock Data - Banking/einfachbank focused
const MOCK_VIDEOS: VideoCardProps[] = [{
  title: 'How Compound Interest Actually Works',
  thumbnail: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&auto=format&fit=crop&q=60',
  duration: '08:45',
  topic: 'Financial Education',
  feel: ['Educational', 'Professional']
}, {
  title: '5 Banking Mistakes Gen Z Makes',
  thumbnail: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&auto=format&fit=crop&q=60',
  duration: '06:30',
  topic: 'Gen Z Banking',
  feel: ['Casual', 'Trendy']
}, {
  title: 'Understanding Your Credit Score',
  thumbnail: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&auto=format&fit=crop&q=60',
  duration: '12:15',
  topic: 'Credit & Loans',
  feel: ['Educational', 'Authentic']
}, {
  title: 'Savings Hacks Nobody Tells You',
  thumbnail: 'https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?w=800&auto=format&fit=crop&q=60',
  duration: '05:20',
  topic: 'Savings Tips',
  feel: ['Energetic', 'Bold']
}, {
  title: "What Banks Don't Want You to Know",
  thumbnail: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&auto=format&fit=crop&q=60',
  duration: '09:40',
  topic: 'Banking Secrets',
  feel: ['Inspiring', 'Authentic']
}, {
  title: 'First Time Home Buyer Guide',
  thumbnail: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&auto=format&fit=crop&q=60',
  duration: '15:30',
  topic: 'Mortgages',
  feel: ['Professional', 'Educational']
}, {
  title: 'Investing 101: Where to Start',
  thumbnail: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&auto=format&fit=crop&q=60',
  duration: '07:55',
  topic: 'Investing',
  feel: ['Educational', 'Calm']
}, {
  title: 'Why Your Bank Account Needs This',
  thumbnail: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=800&auto=format&fit=crop&q=60',
  duration: '04:45',
  topic: 'Banking Tips',
  feel: ['Trendy', 'Energetic']
}];
const COLLECTIONS = ['All', 'Financial Education', 'Gen Z Banking', 'Credit & Loans', 'Savings Tips', 'Banking Secrets', 'Mortgages', 'Investing'];
export function SwipeFile() {
  const [isAddInspirationOpen, setIsAddInspirationOpen] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState('All');
  const handleAddInspiration = (inspiration: any) => {
    console.log('New inspiration added:', inspiration);
    // TODO: Add to swipefile list
  };
  const filteredVideos = selectedCollection === 'All' ? MOCK_VIDEOS : MOCK_VIDEOS.filter(video => video.topic === selectedCollection);
  return <>
      <div className="flex-1 h-full flex flex-col bg-gray-50/50" data-id="element-596">
        {/* Header */}
        <div className="sticky top-0 z-10 bg-white/80 backdrop-blur-md border-b px-8 py-6" data-id="element-597">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6" data-id="element-598">
            <div data-id="element-599">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-600">Swipefile</h1>
              <p className="text-gray-500 mt-1" data-id="element-601">
                Your collection of inspiring content
              </p>
            </div>
            <Button className="bg-[#139191] hover:bg-[#139191]/90 text-white shadow-md gap-2" onClick={() => setIsAddInspirationOpen(true)} data-id="element-602">
              <Plus className="h-4 w-4" data-id="element-603" />
              Add Inspiration
            </Button>
          </div>

          {/* Collections */}
          <div className="mb-4" data-id="element-604">
            <p className="text-sm font-semibold text-gray-700 mb-3" data-id="element-605">
              Collections
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-606">
              {COLLECTIONS.map(collection => <button key={collection} onClick={() => setSelectedCollection(collection)} className={cn('px-4 py-2 rounded-full text-sm font-medium transition-all', selectedCollection === collection ? 'bg-[#139191] text-white shadow-md' : 'bg-white text-gray-700 border border-gray-200 hover:border-[#139191] hover:text-[#139191]')} data-id="element-607">
                  {collection}
                  {collection !== 'All' && <span className="ml-2 text-xs opacity-75" data-id="element-608">
                      (
                      {MOCK_VIDEOS.filter(v => v.topic === collection).length}
                      )
                    </span>}
                </button>)}
            </div>
          </div>

          {/* Search & Filters */}
          <div className="flex flex-col md:flex-row gap-4 items-center" data-id="element-609">
            <div className="relative flex-1 w-full" data-id="element-610">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-611" />
              <Input placeholder="Search inspirations..." className="pl-10 bg-white border-gray-200 focus-visible:ring-[#139191]" data-id="element-612" />
            </div>
            <div className="flex gap-2 w-full md:w-auto" data-id="element-613">
              <Button variant="outline" className="flex-1 md:flex-none gap-2 border-gray-200 text-gray-600 hover:text-[#139191] hover:border-[#139191]/30" data-id="element-614">
                <Filter className="h-4 w-4" data-id="element-615" />
                Filter
              </Button>
              <Button variant="outline" className="flex-1 md:flex-none gap-2 border-gray-200 text-gray-600 hover:text-[#139191] hover:border-[#139191]/30" data-id="element-616">
                <ArrowUpDown className="h-4 w-4" data-id="element-617" />
                Sort
              </Button>
            </div>
          </div>
        </div>

        {/* Video Grid */}
        <div className="flex-1 overflow-auto p-8" data-id="element-618">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6 pb-8" data-id="element-619">
            {filteredVideos.map((video, index) => <VideoCard key={index} {...video} data-id="element-620" />)}
          </div>
        </div>
      </div>

      {/* Add Inspiration Modal */}
      <AddInspirationModal isOpen={isAddInspirationOpen} onClose={() => setIsAddInspirationOpen(false)} onSubmit={handleAddInspiration} data-id="element-621" />
    </>;
}